import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Divider, Button, Form, Input, Modal, message } from 'antd'
import { useDispatch, useSelector, shallowEqual } from 'dva'
import { useHistory } from 'react-router-dom'
import SettlementCard from './SettlementCard'
import SelectAddress, { SelectAddressRefProps } from './SelectAddress'
import { ProductErrorModal } from 'components'
import { ProductErrorModalProps } from 'components/ProductErrorModal'
import AddEdit from 'app/mine/id/components/Address/AddEdit'
import { useRequest } from '@sisyphe/hooks'
import { add } from '@sisyphe/utils'
import * as api from 'services/store'
import './index.less'

const selector = ({ order }) => ({
  orderInfo: order.orderInfo,
})
export default function Settlement() {
  const { orderInfo } = useSelector(selector, shallowEqual)
  const history = useHistory()
  const dispatch = useDispatch()
  const [addressInfo, setAddressInfo] = useState<
    (SwaggerDTO.地址信息 & { consigneeAddress: string }) | undefined
  >()
  const [remark, setRemark] = useState('')
  const [openAddAddress, setOpenAddAddress] = useState(false)
  const addressRef = useRef<SelectAddressRefProps>()
  const [errorOpen, setErrorOpen] = useState(false)
  const [errorType, setErrorType] =
    useState<ProductErrorModalProps['type']>('overInventory')
  const [errorList, setErrorList] = useState<
    Array<SwaggerDTO.校验无法通过的商品信息>
  >([])

  const spuTotals = useMemo(() => {
    return orderInfo.spuInfos?.reduce((num, item) => add(num, item.num, 0), 0)
  }, [orderInfo.spuInfos])

  // 购物车管理-结算接口
  const { run: checkOrderUsingPOST, loading: settlementLoading } = useRequest(
    async params => {
      const { data } = await api.checkOrderUsingPOST(params)
      // 错误信息
      if (data?.unPassData?.length) {
        // 库存不足
        const overInventoryList = data.unPassData.filter(c => c.code === 1000)
        if (overInventoryList.length) {
          setErrorType('overInventory')
          setErrorList([...overInventoryList])
        }
        // 下架
        const offList = data.unPassData.filter(c =>
          [2000, 3000].includes(c.code)
        )
        if (offList.length) {
          setErrorType('off')
          setErrorList(offList)
        }
        setErrorOpen(true)
        return false
      }

      placeOrderUsingPOST(params)
    },
    { manual: true }
  )

  // 购物车管理-提交订单
  const { run: placeOrderUsingPOST, loading } = useRequest(
    async params => {
      const { data: orderCode } = await api.placeOrderUsingPOST(params)
      history.push('/order-success')
      dispatch({ type: 'cart/getShopCartNum' })
      dispatch({
        type: 'order/setOrderSuccessInfo',
        payload: orderCode,
      })
      return orderCode
    },
    { manual: true }
  )

  // 提交
  const onSubmit = () => {
    console.log('====================================')
    console.log(addressInfo)
    console.log('====================================')
    if (!addressInfo?.provinceId) {
      message.warning('收货地址不能为空')
      return
    }
    const params = {
      ...orderInfo,
      remark,
      addressInfo,
    }
    checkOrderUsingPOST(params)
  }

  const productErrorOk = () => {
    setErrorOpen(false)
  }

  useEffect(() => {
    if (!orderInfo) return
    setAddressInfo(orderInfo?.addressInfo)
  }, [orderInfo])

  return (
    <div className="settlement">
      <div className="settlement-title">
        <span>收货人信息</span>
        <span
          className="settlement-add"
          onClick={() => setOpenAddAddress(true)}
        >
          新增收货地址
        </span>
      </div>
      <SelectAddress
        ref={addressRef}
        value={addressInfo?.id}
        onChange={setAddressInfo}
      />
      <Divider />
      <div className="settlement-title">
        <span>商品清单</span>
        <span className="settlement-add" onClick={() => history.push('/cart')}>
          返回修改购物车
        </span>
      </div>
      <SettlementCard data={orderInfo.spuInfos} />
      <Divider />
      <Form.Item label="备注：">
        <Input.TextArea
          value={remark}
          placeholder="请输入备注"
          maxLength={200}
          showCount
          rows={4}
          onChange={e => setRemark(e.target.value)}
        />
      </Form.Item>
      <Divider />
      <div className="total">
        <span>{spuTotals}件商品</span>
        <span>商品总金额：￥{orderInfo?.orderAmount}</span>
      </div>
      <Divider />
      <div className="totalInfo">
        <p>
          <span>应付总额：</span>
          <span className="price">￥{orderInfo?.orderAmount}</span>
        </p>
        <p className="info-address">
          寄送至：{addressInfo?.provinceName}
          {addressInfo?.cityName}
          {addressInfo?.areaName}
          {addressInfo?.address} 收货人：{addressInfo?.addressee}{' '}
          {addressInfo?.linkMobile}
        </p>
      </div>
      <Divider />
      <div className="settlement-submit">
        <Button
          className="settlement-submit-btn"
          type="primary"
          onClick={onSubmit}
          loading={loading || settlementLoading}
        >
          提交采购订单
        </Button>
      </div>
      <Modal
        title="新增收货地址"
        open={openAddAddress}
        width={500}
        onCancel={() => setOpenAddAddress(false)}
        maskClosable={false}
        footer={false}
        keyboard={false}
        destroyOnClose
      >
        <AddEdit
          onCancel={() => setOpenAddAddress(false)}
          onOk={() => addressRef.current?.refresh()}
        />
      </Modal>
      <Modal
        open={errorOpen}
        closable={false}
        width={350}
        onCancel={() => setErrorOpen(false)}
        maskClosable={false}
        footer={false}
        keyboard={false}
        destroyOnClose
      >
        <ProductErrorModal
          onOk={productErrorOk}
          type={errorType}
          data={errorList}
        />
      </Modal>
    </div>
  )
}
